import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=3fc8a0ba&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=3fc8a0ba&prod&scoped=true&lang=css"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=3fc8a0ba&prod&lang=css"
import style2 from "./orderDetails.vue?vue&type=style&index=2&id=3fc8a0ba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc8a0ba",
  null
  
)

export default component.exports